import React from "react";
import { useNavigate } from "react-router-dom"; // optional if using React Router
import "./ErrorPage.css"; // optional for custom styles

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <main className="error-page">
      <div className="error-container">
        <h1 className="error-code">404</h1>
        <h2 className="error-message">Oops! Page Not Found</h2>
        <p className="error-description">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <button className="error-button" onClick={() => navigate("/")}>
          Go Back Home
        </button>
      </div>
    </main>
  );
};

export default ErrorPage;
